import { ElementRef } from "@angular/core";
import { LateralPanelService } from "./../lateral-panel/lateral-panel.service";
import { Component, OnInit, Input, OnDestroy, ViewChild } from "@angular/core";
import { CommonService } from "../common.service";
import { WebcallsService } from "src/app/webcalls.service";
import { DataproviderService } from "src/app/dataprovider.service";
import { ActivatedRoute, Router } from "@angular/router";
import { CoverConfiguratorService } from "../cover-configurator/cover-configurator.service";
import {
  UntypedFormGroup,
  UntypedFormControl,
  NgForm,
  Validators,
  AbstractControl,
  ValidatorFn
} from "@angular/forms";
import { ProgressiveBarService } from "src/app/shared/progressive-bar/progressive-bar.service";
import { AnalyticsLibraryService } from "src/app/analytics-library.service";

import { emailValidator } from './email.validator';

@Component({
  selector: "app-summary",
  templateUrl: "./summary.component.html",
  styleUrls: [
    "./summary.component.scss",
    "./summary.component.responsive.scss",
  ],
  host: {
    class: "d-block p-y-page-summary h-100",
  },
})
export class SummaryComponent implements OnInit, OnDestroy {
  title: string = "b2c.IDS_SUMMARY";
  subtitle: string = "b2c.IDS_SUMMARY_SUB";
  showSubtitle: boolean = true;
  question: string = "b2c.IDS_SUMMARY_QUE";
  activePage: string = "summary";
  nextPage: string = "";
  lateralPanelId: string = "summary-choices-lateral";
  plateUrl: string = "";
  switchesUrl: string = "";
  eventCategory: string = "IDS_GTAG_CATEGORY";
  eventLabel: string = "";
  summaryFormGroup: UntypedFormGroup;
  packageItemDownloaded: boolean = false;
  showLoader: boolean = true;
  minRange: number = 0;
  maxRange: number = 0;

  showSidebar: boolean = false;

  toStartEdit: boolean = false;
  // get internalUnitDescription(): string | null {
  //   return this.ds.getInternalUnit()?.name || null;
  // }

  constructor(
    private ar: ActivatedRoute,
    private ro: Router,
    private cs: CommonService,
    private ws: WebcallsService,
    public ds: DataproviderService,
    private lps: LateralPanelService,
    public ap: AnalyticsLibraryService,
    private confService: CoverConfiguratorService,
    private progressiveBarService: ProgressiveBarService
  ) {
    this.cs.setParams(
      "", //title
      this.subtitle,
      this.question,
      this.activePage,
      this.nextPage,
      false,
      false,
      true, ///8-h
      true,
      null,
      false, ///11-k
      true,
      this.eventCategory,
      this.eventLabel,
      false,
      "b2c.IDS_FOOTERTOOLTIP",
      true,
      this.showSubtitle
    );
    this.updatePlateImageUrl();
    this.updateSwitchImageUrl();
    this.progressiveBarService.setProgressiveBarLengthByPageIndex(11);
    this.cs.showHeaderPage = false;
    this.cs.showFooter = false;
  }

  updatePlateImageUrl() {
    if (this.ds.getPlate()) {
      this.plateUrl = this.confService.getPlateUrl(this.ds.getPlate()["Code3"]);
    }
  }

  updateSwitchImageUrl() {
    if (this.ds.getSwitch()) {
      this.switchesUrl = this.confService.getSwitchUrl(
        this.ds.getSwitch()["id"],
        3
      );
    }
  }

  filterRooms(room: {}) {
    return (
      room["SubRooms"][0]["Quantity"] && room["SubRooms"][0]["Quantity"] >= 0
    );
  }

  ngOnInit() {
    if (this.ds.getShapeID()) {
      this.eventLabel = "IDS_QUOTATION_SHAPE_"
        .concat(this.ds.getShapeID().toString())
        .concat("_TECHNOLOGY_".concat(this.ds.getTechnologyID().toString()));
    } else {
      this.eventLabel = "IDS_QUOTATION"
        .concat("_TECHNOLOGY_".concat(this.ds.getTechnologyID().toString()))
        .concat("_FINISHING")
        .concat(this.ds.getFinishingID().toString());
    }
    this.cs.setLabelEvent(this.eventLabel);
    this.cs.setEventAction("Invio", false);
    this.initForm();
    this.wsCall();
  }

  ngOnDestroy() {
    this.ds.summaryFormData = this.summaryFormGroup.value;
  }

  reviewBtnClick() {
    this.lps.open(this.lateralPanelId);
  }

  validateEmail(emailAddr: string): ValidatorFn {
    return (control: AbstractControl): {[key: string]: any} | null => {
      var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
      return emailAddr.match(mailformat) ? {'emailDomain': true} : null;
    }
  }

  privacyLinkClick() {
    this.ro.navigate(["/wiz/privacy"], { relativeTo: this.ar });
  }

  wsCall() {
    this.cs.changeSummaryLoaderStatus(true);
    let that = this;
    this.packageItemDownloaded = false;
    this.setSendButtonStatus();
    this.ws
      .getAllPackageItems(
        this.ds.getQuotationData(),
        this.ds.getLocalization(),
        this.ds.getTotalPoints(),
        this.ds.getAddons()
      )
      .subscribe((data) => {
        if (Array.isArray(data)) {
          that.ds.setPackageItems(data);
          this.minRange = that.ds.getRangeMin();
          this.maxRange = that.ds.getRangeMax();
          that.packageItemDownloaded = true;
          this.setSendButtonStatus();
          that.showLoader = false;
          this.cs.changeSummaryLoaderStatus(false);
          this.cs.showFooter = true;
          this.cs.showHeaderPage = true;
          this.analyticsSummaryFormCall('IDS_SUMMARY_FORM_DISPLAYED');
          this.toStartEdit = true;
        }
      });
  }

  initForm() {
    this.summaryFormGroup = new UntypedFormGroup({
      name: new UntypedFormControl(null, [Validators.required]),
      surname: new UntypedFormControl(null, [Validators.required]),
      email: new UntypedFormControl(null, [Validators.required, emailValidator()]), //Validators.email
      privacy: new UntypedFormControl(null, [Validators.requiredTrue]),
      marketing: new UntypedFormControl(null, []),
    });

    let formData = this.ds.summaryFormData;
    if (formData) {
      this.summaryFormGroup.setValue(formData);
      this.setSendButtonStatus();
    }

    this.summaryFormGroup.statusChanges.subscribe((status) => {
      if (status === "VALID") {
        this.ds.summaryFormData = this.summaryFormGroup.value;
        this.setSendButtonStatus();
      } else {
        this.setSendButtonStatus();
      }
    });
  }

  onCloseTooltip() {
    this.showSidebar = false;
  }

  private setSendButtonStatus(): void {
    let formValid = this.summaryFormGroup.status === "VALID";

    if (formValid && this.packageItemDownloaded) {
      this.cs.updateSendBtn(true);
    } else {
      this.cs.updateSendBtn(false);
    }
  }

  analyticsSummaryFormCall(action: string) {
    this.ap.sendGAEventWithInfoString(action, [{ key:'serie', value:  "IDS_FINISHING"+this.ds.getFinishing().ID}]);
  }

  analyticsSummaryEditCall() {
    if (this.toStartEdit) {
      this.analyticsSummaryFormCall('IDS_SUMMARY_FORM_FILLING');
      this.toStartEdit = false;
    } else {
      return false;
    }
  }
}
